import { Route, Switch } from 'react-router';
import { AuditTrail } from './pages/portal/AuditTrail/AuditTrail';
import { Portal } from './pages/portal/Portal';
import { Home } from './pages/Home';
import { PostLogin } from './pages/auth/PostLogin';
import { NotFound } from './pages/NotFound';
import { ProtectedRoute} from './components/ProtectedRoute';
import { AuthenticationProvider } from './msal/AuthenticationContext';
import { TenantProvider } from './context/TenantContext';
import { AuthorizationProvider } from './context/AuthorizationContext';
import { ErrorHandlingProvider } from './context/ErrorHandlingContext';
import { NotificationProvider } from './context/NotificationContext';
import { Unauthorized } from './pages/auth/Unauthorized';
import { CreateTenant } from './pages/CreateTenant';

import './utils/arrayExtensions';

import './App.module.scss';
import './custom.css'

const RootApp = () => {
    return (
        <ErrorHandlingProvider>
            <NotificationProvider>
                <AuthenticationProvider>
                    <TenantProvider>
                        <AuthorizationProvider>
                            <Switch>
                                <Route exact path='/' component={Home} />                    
                                <Route exact path='/post-login-spa' component={PostLogin} />                        
                                <Route exact path='/unauthorized' component={Unauthorized} />
                                <Route exact path='/create-tenant' component={CreateTenant} />

                                <ProtectedRoute exact path='/portal/audit-trail' component={AuditTrail} />                       

                                <ProtectedRoute path='/portal' component={Portal} />                        
                                <Route path='*' component={NotFound} />
                            </Switch>
                        </AuthorizationProvider>
                    </TenantProvider>
                </AuthenticationProvider>
            </NotificationProvider>
        </ErrorHandlingProvider>
    );    
}

export const App = RootApp;
